import { API, Auth } from 'aws-amplify';

const publicHeaders = {
    'Content-Type': 'application/json',
    'X-Api-Key': process.env.REACT_APP_API_KEY,
};

const privateHeaders = async () => ({
    authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`,
    'Content-Type': 'application/json',
    'X-Api-Key': process.env.REACT_APP_API_KEY,
    'x-oam-identity': `${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
});

export const validateAccount = (body) => {
    const request = {
        body,
        headers: publicHeaders,
    };
    return API.post('OamApiPublic', '/account/validate', request);
};

export const retrieveUsername = (body) => {
    const request = {
        body,
        headers: publicHeaders,
    };

    return API.post('OamApiPublic', '/account/forgot', request);
};

export const getAccounts = async () => {
    const request = {
        headers: await privateHeaders(),
    };

    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.get('OamApiPrivate', `/account/${cognitoSub}`, request);
};

export const generateBarcode = async (accountNumber) => {
    const ph = await privateHeaders();
    const request = {
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };

    return API.post('OamApiPrivate', '/account/barcode', request);
};

export const getStatements = async (accountNumber) => {
    const ph = await privateHeaders();
    const request = {
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };

    return API.get('OamApiPrivate', `/document/metadata`, request);
};

export const getProfile = async () => {
    const request = {
        headers: await privateHeaders(),
    };

    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.get('OamApiPrivate', `/profile/lookup/${cognitoSub}`, request);
};

export const updateProfile = async (updatedData) => {
    const updatedArray = [];
    for (const [fieldName, value] of Object.entries(updatedData)) {
        updatedArray.push({ fieldData: value, fieldToUpdate: fieldName });
    }
    const request = {
        body: {
            updateArray: updatedArray,
        },
        headers: await privateHeaders(),
    };

    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.post('OamApiPrivate', `/profile/maintenance/${cognitoSub}`, request);
};

export const getStatementsPDF = async (link) => {
    const ph = await privateHeaders();
    const headers = {
        ...ph,
        Accept: 'application/octet-stream, application/pdf',
    };

    return API.get('OamApiPrivate', `/document/file/${link}.pdf`, {
        headers,
        responseType: 'blob',
    });
};

export const addNewAccount = async (accountNumber) => {
    const ph = await privateHeaders();
    const request = {
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };
    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.post('OamApiPrivate', `/account/add/${cognitoSub}`, request);
};

export const verifyOTP = async (accountNumber, verificationCode) => {
    const ph = await privateHeaders();
    const request = {
        body: {
            verificationCode: verificationCode,
        },
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };
    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.post('OamApiPrivate', `/account/verify/${cognitoSub}`, request);
};

export const getPlans = async (accountNumber) => {
    const ph = await privateHeaders();
    const request = {
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };
    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.get('OamApiPrivate', `/account/plan/${cognitoSub}`, request);
};

export const getTransactions = async (accountNumber, queryParams) => {
    const ph = await privateHeaders();
    const request = {
        headers: {
            ...ph,
            'x-oam-account-number': accountNumber,
        },
    };
    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;
    queryParams = new URLSearchParams(queryParams).toString();
    return API.get('OamApiPrivate', `/account/transaction/${cognitoSub}?${queryParams}`, request);
};

export const getNotifications = async (queryParams) => {
    const request = {
        headers: await privateHeaders(),
    };

    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;
    queryParams = new URLSearchParams(queryParams).toString();

    return API.get('OamApiPrivate', `/account/${cognitoSub}/notification?${queryParams}`, request);
};

export const updateNotifications = async (notifications) => {
    const request = {
        body: notifications,
        headers: await privateHeaders(),
    };

    const user = await Auth.currentUserInfo();
    const { sub: cognitoSub } = user.attributes;

    return API.patch('OamApiPrivate', `/account/${cognitoSub}/notification`, request);
};
